import { concat } from '@ember/helper';
import { t } from 'ember-intl';
import and from 'ember-truth-helpers/helpers/and';
import eq from 'ember-truth-helpers/helpers/eq';
import BvTooltip from 'volta/components/bv-tooltip';
import classNames from 'volta/helpers/class-names';
import orElse from 'volta/helpers/or-else';

import type { TOC } from '@ember/component/template-only';
import type { TPlanningMethodology, TReorderStrategy } from 'volta/models/types/planning-settings';

interface BvMethodoIconSignature {
  Args: {
    isProtected?: boolean;
    methodology?: TPlanningMethodology;
    reorderStrategy?: TReorderStrategy;
  };
  Element: HTMLDivElement;
}

const BvMethodoIconComponent: TOC<BvMethodoIconSignature> = <template>
  <div
    class={{classNames
      'bv-methodo-icon'
      (if
        (eq @methodology 'BUFFER')
        'bv-methodo-icon--buffer'
        (if
          (and (eq @methodology 'MRP') (eq (orElse @reorderStrategy 'MTS') 'MTS'))
          'bv-methodo-icon--mts'
          (if
            (and (eq @methodology 'MRP') (eq @reorderStrategy 'MTO'))
            'bv-methodo-icon--mto'
            'bv-methodo-icon--unmanaged'
          )
        )
      )
      (if @isProtected 'bv-methodo-icon--protected')
    }}
    ...attributes
  >
    {{#if (eq @methodology 'BUFFER')}}
      <BvTooltip @text={{t 'buffered'}} />
    {{else if (eq @methodology 'MRP')}}
      <BvTooltip @text={{concat (t 'mrp') (if @isProtected (concat ' - ' (t 'protected')))}} />
    {{else}}
      <BvTooltip @text={{t 'notBuffered'}} /><span class='empty'></span>
    {{/if}}
    <span class='out'></span>
    <span class='middle'></span>
    <span class='inner'></span>
  </div>
</template>;

export default BvMethodoIconComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    BvMethodoIcon: typeof BvMethodoIconComponent;
    'bv-methodo-icon': typeof BvMethodoIconComponent;
  }
}
